export default {
  user: {},
  token: '',
  email: 'claudioyvens10@gmail.com',
  password: '91734371315',
  process: false,
  successMessage: false,
  errorMessage: false,
  isAdmin: false,
  isTeacher: false,
  isEditor: false,
  DialodPermissionDenied: false,
}
